import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";

<template>
  <a title={{i18n "waze.user_dropdown.title"}}>
    {{dIcon "w-bell"}}
  </a>
</template>
